<template>
  <div class="my-machines-invoice-history">
    <div class="my-machines-invoice-history__actions">
      <oie-base-input v-model="searchPhrase" :placeholder="t('filterMyMachinesOrderHistory')" class="my-machines-invoice-history__search">
        <template #iconPrepend>
          <oie-base-icon icon="filter-icon" size="s"></oie-base-icon>
        </template>
      </oie-base-input>

      <div class="my-machines-invoice-history__dates">
        <datepicker
          ref="fromDate"
          v-model="fromDate"
          :placeholder="t('fromDateLabel')"
          :monday-first="true"
          wrapper-class="datepicker"
          calendar-class="datepicker-calendar"
          input-class="datepicker-input"
          format="yyyy-MM-dd"
          :language="language"
          :full-month-name="true"></datepicker>
        <datepicker
          ref="toDate"
          v-model="toDate"
          :placeholder="t('toDateLabel')"
          :monday-first="true"
          wrapper-class="datepicker"
          calendar-class="datepicker-calendar"
          input-class="datepicker-input"
          format="yyyy-MM-dd"
          :language="language"
          :full-month-name="true"></datepicker>
      </div>
    </div>
    <div v-element-loader="{ endpoint: 'my-machines/invoices' }" class="my-machines-invoice-history__list">
      <ul v-if="invoices">
        <li v-for="invoice in invoices" :key="invoice.invoiceNumber">
          <oie-invoice-history-item :invoice="invoice"></oie-invoice-history-item>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { en } from 'vuejs-datepicker/dist/locale'
import httpService from '../../../core/http-service'
import Datepicker from 'vuejs-datepicker/dist/vuejs-datepicker.esm.js'
import _ from 'lodash'

export default {
  components: {
    Datepicker
  },
  props: {
    id: {
      type: Object,
      required: true
    }
  },
  data() {
    // The dates start out set rather than being set in mounted: setting them there also tripped the
    // watcher, so every visit searched twice, on a query that can take seconds (OC-2836).
    const fromDate = new Date()
    fromDate.setFullYear(fromDate.getFullYear() - 1)

    return {
      invoices: null,
      fromDate,
      toDate: new Date(),
      searchPhrase: '',
      language: en
    }
  },
  computed: {
    queryParams() {
      return `${this.fromDate}|${this.toDate}|${this.searchPhrase}`
    }
  },
  watch: {
    queryParams: _.debounce(function() {
      this.getInvoiceHistory()
    }, 400)
  },
  mounted() {
    this.getInvoiceHistory()
  },
  methods: {
    async getInvoiceHistory() {
      const response = await httpService.get('my-machines/invoices', { ...this.id, fromDate: this.fromDate, toDate: this.toDate, searchPhrase: this.searchPhrase })
      this.invoices = response.data
    }
  }
}
</script>

<style lang="scss">
.my-machines-invoice-history__actions {
  display: flex;
  gap: measure(eighth);
  flex-wrap: wrap;
  margin-bottom: measure(half);
}

.my-machines-invoice-history__search {
  margin-right: auto;

  @include media(medium) {
    max-width: 20rem;
  }
}

.my-machines-invoice-history__dates {
  display: flex;
  flex-direction: column;
  gap: measure(eighth);
  width: 100%;

  @include media(medium) {
    flex-direction: row;
    width: auto;
  }
}

.my-machines-invoice-history__list > ul{
  @include reset-list;
}

.my-machines-invoice-history__list > ul > li:not(:last-child){
  margin-bottom: measure(half);
}
</style>
